export const RUNBOOKS_TEMPLATES_MAINTAIN = 'runbooks:templates:maintain'
export const RUNBOOKS_TEMPLATES_USE = 'runbooks:templates:use'

export function isAllowed(context, permission) {
    if (!context?.permissions) {
        return false
    }

    const { permissions } = context
    const invert = permission.startsWith('!')
    if (invert) {
        return !permissions.includes(permission.substring(1))
    }

    return permissions.includes(permission)
}

export function isAnyAllowed(context, permissions) {
    return permissions.some((permission) => isAllowed(context, permission))
}

export function isAllAllowed(context, permissions) {
    return permissions.every((permission) => isAllowed(context, permission))
}
